import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { PARTNERSHIP_EMAIL } from "../lib/content";

export default function CTABanner({
  title = "Partner with Jollof Fit Kingdom",
  desc = "Join Jollof Fit Kingdom in building the world's most complete connected health ecosystem.",
}) {
  return (
    <section className="relative mx-auto w-full max-w-7xl px-6 py-24 md:px-10">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-gold/20 bg-gradient-to-b from-[#12100a] to-[#080808] px-8 py-16 text-center md:px-16">
          <div className="pointer-events-none absolute inset-0 grid-lines opacity-30" />
          <div className="pointer-events-none absolute -top-24 left-1/2 h-48 w-48 -translate-x-1/2 rounded-full bg-gold/10 blur-3xl" />
          <div className="relative">
            <h2 className="mx-auto max-w-3xl font-heading text-3xl font-medium tracking-tight text-white md:text-4xl">
              {title}
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base text-zinc-400">{desc}</p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
              <Link to="/business-partnerships" data-testid="cta-partnerships" className="btn-gold">
                Business Partnerships
              </Link>
              <a href={`mailto:${PARTNERSHIP_EMAIL}`} data-testid="cta-email" className="btn-secondary">
                {PARTNERSHIP_EMAIL}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
